import { WprBaseViewCore } from '../view/WprBaseViewCore';
import { WprHttpErrorInfo } from './WprHttpErrorInfo';
import { WprFramework } from '../WprFramework';
import { WprBaseObject } from '../WprBaseObject';

/**
 * サービス基本クラス
 */
export abstract class WprBaseService extends WprBaseObject {
	// override メソッド  --------------------------------------------------------
	/**
	 * Post通信実行処理
	 * @param url URL
	 * @param request リクエスト情報
	 * @returns 通信結果Promiseオブジェクト 
	 */
	public abstract executePost(url: string, request: any): Promise<any>;
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * Post通信処理
	 * @param viewCore ビュー情報
	 * @param url URL
	 * @param request リクエスト情報 
	 * @param resMethod 結果処理メソッド
	 */
	public doPost(viewCore: WprBaseViewCore, url: string, request: any, resMethod: (result: any) => void): void {
		WprFramework.getInstance().startWait();
		this.addInfoLog(`サービス(doPost)：開始[${url}][${viewCore.objectName}]`);
		this.executePost(url, request).then((result) => {
			if (result['status']) {
				const status = result['status'] as string;
				if (status) {
					if (status.replace(/0/g, '') !== '') {
						// HTTPステータスでsuccess・200（OK）は許容
						if (status !== 'success' && status !== '200') {
							let message = result['message'] as string;
							this.addErrorLog(`サービス(doPost)：エラー[${url}][${status}][${message}][${viewCore.objectName}]`);
							viewCore.onServiceError(url, status, message);
							return;
						}
					} 
				}
			}
			this.addInfoLog(`サービス(doPost)：成功[${url}][${viewCore.objectName}]`);
			resMethod(result);
		}).catch((error) => {
			const einfo = error as WprHttpErrorInfo;
			if (einfo) {
				viewCore.addErrorLog(`サービス(doPost)：通信エラー${einfo.message}[${einfo.url}]`);
				viewCore.onServiceError(einfo.url, '', einfo.message, einfo.error);
			}
			else {
				viewCore.addErrorLog(`サービス(doPost)：通信エラー発生時にWprHttpErrorInfo以外の情報が返されました。[${url}]`);
				viewCore.onServiceError(url, '', '未定義エラー');
			}
		}).finally(() => {
			WprFramework.getInstance().endWait();
		});
	}

	public doPostToExternalAPI(viewCore: WprBaseViewCore, url: string, request: any, resMethod: (result: any) => void): void {
		WprFramework.getInstance().startWait();
		this.addInfoLog(`サービス(doPost)：開始[${url}][${viewCore.objectName}]`);
		this.executePost(url, request).then((result) => {
			if (result['status']) {
				this.addInfoLog(`サービス(doPost)実行結果[${url}][${viewCore.objectName}][STATUS:${result['status']}]`);
			}
			resMethod(result);
		}).catch((error) => {
			const einfo = error as WprHttpErrorInfo;
			// if (einfo) {
			// 	viewCore.addErrorLog(`サービス(doPost)：通信エラー${einfo.message}[${einfo.url}]`);
			// 	viewCore.onServiceError(einfo.url, '', einfo.message, einfo.error);
			// }
			// else {
			// 	viewCore.addErrorLog(`サービス(doPost)：通信エラー発生時にWprHttpErrorInfo以外の情報が返されました。[${url}]`);
			// 	viewCore.onServiceError(url, '', '未定義エラー');
			// }
		}).finally(() => {
			WprFramework.getInstance().endWait();
		});

	}
	// --------------------------------------------------------------------------
}